import React, { memo } from 'react';
import { MedVoxTask } from '../../../models/MedVox/MedVoxTask';
import { useAudioPlayers } from '../../../hooks/components/useAudioPlayers/useAudioPlayers';
import { AudioSrc } from '../../../hooks/components/useMedVoxTasks/types';
import styles from './styles.module.css';

interface ExpandableRowProps {
  record: MedVoxTask;
  audioSrc?: AudioSrc;
}

const ExpandableRow: React.FC<ExpandableRowProps> = ({ record, audioSrc }) => {
  const audioPlayers = useAudioPlayers(record, audioSrc);

  return <div className={styles.callsContainer}>{audioPlayers}</div>;
};

export default memo(ExpandableRow);
